import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import * as $ from 'jquery';
import { constants } from '../constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SuspendLineEquipService } from "./suspend-line-equip.service";

declare var $: any;

@Component({
  selector: 'app-suspend-line-equip',
  templateUrl: './suspend-line-equip.component.html',
  styleUrls: ['./suspend-line-equip.component.scss']
})
export class SuspendLineEquipComponent implements OnInit {
  numericPattern = "";
  alphanumericPattern = "";
  emailPattern = "";
  datePattern = "";
  suspendLineForm: FormGroup;
  isBtnDisabled = false;
  //dato quemado que viene de WS
  lineaSolicitada = "";
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isModalReload = false;
  //Modal para confirmar la suspensión
  isShowModalConfirmation = false;
  modalTitleConfirmation = "";
  modalContentConfirmation = "";
  modalContentConfirmationEquip = "";
  //carga datos correspondientes a la linea seleccionada
  selectedLine = false;
  imei = constants.IMEI_TITLE;
  phoneBrand: any;
  phoneImei: any;
  listLineData: any;
  listLines: any;
  types = {
    line: constants.STRING_LINE,
    equip: constants.STRING_EQUIP,
    line_equip: constants.STRING_LINE_EQUIP
  }
  selectedType = constants.STRING_LINE;
  isLoadingLines = false;

  SLINE = constants.STRING_LINE;
  SEQUIP = constants.STRING_EQUIP;
  SBOTH = constants.STRING_LINE_EQUIP;

  constructor(public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private _router: Router, private suspendLineEquipService: SuspendLineEquipService) { }
  /**
  * Description: Método que inicializa y carga las variables del formulario
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  ngOnInit() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.getClientLinesLists();
    this.setTooltips();
    this.chekckOptionsSelected();
    //validaciones de formulario
    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;
    this.alphanumericPattern = constants.REGEX_ALPHANUMERIC_PATTERN;
    this.emailPattern = constants.REGEX_EMAIL_PATTERN;
    //se inicializan los inputs para las validaciones con sus respectivas expresiones regulares
    this.suspendLineForm = this.formbuilder.group({
      inputPhone: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputEmail: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      inputKeyNumber: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputLines: ['', [Validators.required]],
    });
  }


  /**
  * Description: Método que valida que los datos esten ingresados correctamente 
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  suspendValidation() {
    // Validacion de campos 
    if (this.suspendLineForm.get('inputPhone').invalid
      || this.suspendLineForm.get('inputEmail').invalid
      || this.suspendLineForm.get('inputKeyNumber').invalid
      || this.suspendLineForm.get('inputLines').invalid) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }

    if (!this.LANG.isValidPhoneZero(this.suspendLineForm.get('inputLines').value) ||
    !this.LANG.isValidPhoneZero(this.suspendLineForm.get('inputPhone').value)) {
      //si no tiene el prefijo 0 no puede seguir
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
      this.isShowModal = true;
      return false;
    }

    this.isShowModalConfirmation = true;

  }

  suspendConfirmed() {
    this.isBtnDisabled = true;
    this.isShowModalConfirmation = false;
    const userData = JSON.parse(localStorage.getItem("userData"));
    let jsonData = {
      "identification": userData.documentId,
      "msisdn": this.suspendLineForm.get('inputLines').value,
      "imei": this.imei,
      "alternateMsisdn": this.suspendLineForm.get('inputPhone').value,
      "email": this.suspendLineForm.get('inputEmail').value,
      "verificationKey": this.suspendLineForm.get('inputKeyNumber').value,
      "customerAccountId": userData.customerAccountId,
      "type": this.selectedType
    };

    this.suspendLineEquipService.suspendLineEquipRequest(jsonData).subscribe((data => {
      //habilitar botones
      this.isBtnDisabled = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('SUPEND_LINE_EQUIP_MODAL_SUSPEND_ERROR');        
        this.isShowModal = true;
        return;
      }

      this.isModalReload = true;
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
      if(this.selectedType === this.types.line){
        this.modalContent = this.LANG.getLangText('SUPEND_LINE_EQUIP_MODAL_CONFIRMATION_PART1') + data["obj"].ticket 
        + this.LANG.getLangText('SUPEND_LINE_EQUIP_MODAL_CONFIRMATION_PART2') ;
      } else {
        this.modalContent = this.LANG.getLangText('SUPEND_LINE_EQUIP_MODAL_CONFIRMATION_PART1B') + data["obj"].ticket 
        + this.LANG.getLangText('SUPEND_LINE_EQUIP_MODAL_CONFIRMATION_PART2B') ;        
      }
      this.isShowModal = true;

    }),
      (err) => {
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });

  }

  /**
   * Description: Método que selecciona el tipo de liberación
   * Autor: Steven Sterling
   * @param id identificado del tipo
   * @return N/A
   */
  setSelectedType(id) {
    this.selectedType = constants.STRING_LINE;
    if (id == 2) {
      this.selectedType = constants.STRING_EQUIP;
    } else if (id == 3) {
      this.selectedType = constants.STRING_LINE_EQUIP;
    }
  }

  /**
  * Description: Método que cierra el modal
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  hideModal() {
    this.isShowModal = false;
    this.isShowModalConfirmation = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }
  /**
  * Description: Método que realiza el el cambio de estilos al seleccionar opciones de suspensión
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  chekckOptionsSelected() {
    //cambio de estilos al seleccionar opciones para suspension de linea
    $('.defaultOptionCheck').parent('.image-checkbox').addClass('image-checkbox-checked');
    $('.defaultOptionCheck').attr('checked', true);
    $('.optionCheck').on('change', e => {
      let nodeEl = $(e.target);
      $('.optionCheck').parent('.image-checkbox').removeClass('image-checkbox-checked');
      if ($(e.target).is(':checked')) {
        let value = $(e.target).val();
        console.log("IS CHECKED value: " + value);
        $(e.target).parent('.image-checkbox').addClass('image-checkbox-checked');
      }
    });
  }

  /**
    * Description: Método que setea la información de los tooltips de la página
    * Autor: Steven Sterling
    * @param N/A
    * @return N/A
    */
  setTooltips() {
    $('#tooltipMyline').popover({
      html: true,
      title: 'Titulo MyLine',
      content: "Descripcion MyLine"
    });
    $('#tooltipPhoneNumber').popover({
      html: true,
      title: 'Titulo PhoneNumber',
      content: "Descripcion PhoneNumber"
    });
    $('#tooltipEmail').popover({
      html: true,
      title: 'Titulo Email',
      content: "Descripcion Email"
    });
    $('#tooltipKeyNumber').popover({
      html: true,
      title: 'Titulo KeyNumber',
      content: "Descripcion KeyNumber"
    });
  }
  /**
    * Description: Método que obtiene la informacion de las lineas del cliente con sus datos
    * Autor: Steven Sterling
    * @param N/A
    * @return N/A
    */
  getClientLinesLists() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    let documentId = userData.documentId;
    const customerAccountId = userData.customerAccountId;
    this.isLoadingLines = true;
    this.suspendLineEquipService.getAllUserLines(customerAccountId).subscribe((data => {
      //habilitar botones
      this.isLoadingLines = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('RELEASE_LINE_EQUIP_LABEL_MODAL_ERROR_NO_LINES');
        this.isShowModal = true;
        return;
      }
      //llena la lista
      let item = null;
      this.listLines = [];
      for (var k in data['obj'].basicDataOfMobileLine) {
        item = data['obj'].basicDataOfMobileLine[k];
        this.listLines.push({ "id": item.msisdn, "linea": item.msisdn });
      }
    }),
      (err) => {
        this.isLoadingLines = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
 * Description: Método que obtiene el imei y marca de una linea
 * Autor: Steven Sterling
 * @param N/A
 * @return N/A
 */
  handleImei() {

    this.phoneBrand = "";
    this.imei = "";
    this.phoneImei = "";
    this.selectedLine = false;
    //obtenemos la linea seleccionada con:
    this.isBtnDisabled = true;
    this.isLoadingLines = true;
    this.suspendLineEquipService.getInfoLines(this.suspendLineForm.get('inputLines').value).subscribe((data => {
      //habilitar botones
      this.isLoadingLines = false;
      this.isBtnDisabled = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        return;
      }
      this.phoneBrand = data['obj'].brand;
      this.imei = data['obj'].imei;
      this.phoneImei = data['obj'].model;
      this.selectedLine = true;

    }),
      (err) => {
        this.isBtnDisabled = false;
        this.isLoadingLines = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

}